export class ApiService {
    // Method to evaluate a script
    evaluateScript(script, returnKotlinVal = false) {
        // Construct a JSON object with both the script and the extra variable
        var requestBody = JSON.stringify({
            script: encodeURIComponent(script), 
            returnKotlin: returnKotlinVal
        });

        // Send a POST request to '/api/evaluator' endpoint with the encoded script
        return fetch('/api/evaluator', {
            method: 'POST',
            headers: {
                'Content-Type': 'text/plain'
            },
            body: requestBody
        })
        // Convert server's response to text
        .then(response => response.text())
        // Catch and throw any errors during the fetch process
        .catch(error => {
            console.error('Client-Side Error:', error);
            throw error;
        });
    }

    createDump() {
        return fetch('/api/create_dump', {
            method: 'POST',
            headers: {
                'Content-Type': 'text/plain'
            }
        })
        .then(response => response.text())
        .then(data => {
            alert(data);  // Displaying the server's response in an alert. Adjust as needed.
        })
        .catch((error) => {
            console.error('Error:', error);
            alert('Error creating dump. Please try again.');
        });
    }
}



